import HomepageHealthcareCardImage from "@portal/app/_components/resources/images/homepage_healthcare_card.webp";
import HomepageHealthcareSplashImage from "@portal/app/_components/resources/images/homepage_healthcare_splash.webp";
import HomepageHealthcareSplashMobileImage from "@portal/app/_components/resources/images/homepage_healthcare_splash.m.webp";
import HomepageBusinessSplashImage from "@portal/app/_components/resources/images/homepage_business_splash.webp";
import HomepageBusinessCardImage from "@portal/app/_components/resources/images/homepage_business_card.webp";
import HomepageTechnologyCardImage from "@portal/app/_components/resources/images/homepage_technology_card.jpeg";
import HomepageTechnologySplashImage from "@portal/app/_components/resources/images/homepage_technology_splash.webp";
import HomepageTradeCardImage from "@portal/app/_components/resources/images/homepage_trade_card.webp";
import HomepageTradeSplashImage from "@portal/app/_components/resources/images/homepage_trade_splash.webp";
import { StaticImageData } from "next/image";

export const HOME_PAGE_SEARCH_RESULTS_SIZE = 6;
export const HOME_PAGE_DEFAULT_INDUSTRY: GQL.VocationIndustry = "HEALTH";

type HomepageIndustry = {
  label: string;
  industry: GQL.VocationIndustry;
  cardImage: StaticImageData;
  splashImage: StaticImageData;
  splashImageMobile?: StaticImageData;
  numCareers: number;
};
export const affiliateIndustries: HomepageIndustry[] = [
  {
    label: "Healthcare",
    industry: "HEALTH",
    cardImage: HomepageHealthcareCardImage,
    splashImage: HomepageHealthcareSplashImage,
    splashImageMobile: HomepageHealthcareSplashMobileImage,
    numCareers: 44,
  },
  {
    label: "Technology",
    industry: "TECHNICAL_AND_COMMUNICATIONS",
    cardImage: HomepageTechnologyCardImage,
    splashImage: HomepageTechnologySplashImage,
    numCareers: 11,
  },
  {
    label: "Business",
    industry: "BUSINESS_AND_OFFICE",
    cardImage: HomepageBusinessCardImage,
    splashImage: HomepageBusinessSplashImage,
    numCareers: 20,
  },
  {
    label: "Trade and Industry",
    industry: "TRADE_AND_INDUSTRY",
    cardImage: HomepageTradeCardImage,
    splashImage: HomepageTradeSplashImage,
    numCareers: 23,
  },
];
